import { format, isSameDay } from "date-fns";

import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";
import type { useTranslation } from "react-i18next";

export const getReleaseDate = (
  firstPartTime: TimeStamp | null,
  lastPartTime: TimeStamp | null,
  t: ReturnType<typeof useTranslation>["t"]
): {
  openDate: string;
  openTime: string;
} => {
  if (firstPartTime === null) {
    return {
      openDate: "",
      openTime: "",
    };
  }
  const firstDatetime = new Date(firstPartTime.seconds * 1000);
  const firstDate = format(firstDatetime, "yyyy/M/d");
  const firstDayDisplay = t(
    `common.string.dayOfWeek.${format(firstDatetime, "E")}`
  );
  const firstTime = format(firstDatetime, "HH:mm");

  const isSingleDay =
    lastPartTime === null ||
    isSameDay(firstDatetime, new Date(lastPartTime.seconds * 1000));
  if (isSingleDay) {
    return {
      openDate: `${firstDate}(${firstDayDisplay})`,
      openTime: firstTime,
    };
  }

  const lastDatetime = new Date(lastPartTime.seconds * 1000);
  const lastDate = format(lastDatetime, "yyyy/M/d");
  return {
    openDate: `${firstDate} 〜 ${lastDate}`,
    openTime: "",
  };
};
